/**
 * Ingredient spotlight: dash indicators switch slides; auto-advances on a steady
 * interval. Pauses on hover, focus-in, or hidden tab.
 */
(function () {
  var AUTO_MS = 3600;
  var autoTimers = new WeakMap();
  var pausedByVisibility = document.visibilityState === 'hidden';

  function getActiveIndex(slides) {
    var i;
    for (i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function setActive(root, index) {
    var slides = root.querySelectorAll('[data-ingredient-slide]');
    var dots = root.querySelectorAll('[data-ingredient-dot]');
    if (!slides.length || !dots.length) return;

    var idx = Math.max(0, Math.min(index, slides.length - 1));

    slides.forEach(function (slide, i) {
      var isActive = i === idx;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        slide.removeAttribute('hidden');
      } else {
        slide.setAttribute('hidden', '');
      }
    });

    dots.forEach(function (dot, i) {
      var isActive = i === idx;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      dot.tabIndex = isActive ? 0 : -1;
    });
  }

  function clearTicker(root) {
    var id = autoTimers.get(root);
    if (id != null) {
      clearTimeout(id);
      autoTimers.delete(root);
    }
  }

  function startTicker(root) {
    clearTicker(root);
    if (pausedByVisibility) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var slides = root.querySelectorAll('[data-ingredient-slide]');
    if (slides.length < 2) return;

    function tick() {
      autoTimers.delete(root);
      if (pausedByVisibility) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var slideList = root.querySelectorAll('[data-ingredient-slide]');
      if (slideList.length < 2) return;
      var next = (getActiveIndex(slideList) + 1) % slideList.length;
      setActive(root, next);
      var id = window.setTimeout(tick, AUTO_MS);
      autoTimers.set(root, id);
    }

    var id = window.setTimeout(tick, AUTO_MS);
    autoTimers.set(root, id);
  }

  function restartTicker(root) {
    clearTicker(root);
    startTicker(root);
  }

  function init(root) {
    var slides = root.querySelectorAll('[data-ingredient-slide]');
    var dots = root.querySelectorAll('[data-ingredient-dot]');
    if (!slides.length || !dots.length) return;

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        setActive(root, index);
        restartTicker(root);
      });
      dot.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var dir = event.key === 'ArrowRight' ? 1 : -1;
        var idx = Array.prototype.indexOf.call(dots, dot);
        var next = Math.max(0, Math.min(idx + dir, dots.length - 1));
        setActive(root, next);
        dots[next].focus();
        restartTicker(root);
      });
    });

    var hoverDepth = 0;
    root.addEventListener('mouseenter', function () {
      hoverDepth += 1;
      clearTicker(root);
    });
    root.addEventListener('mouseleave', function () {
      hoverDepth -= 1;
      if (hoverDepth <= 0) {
        hoverDepth = 0;
        startTicker(root);
      }
    });

    root.addEventListener('focusin', function () {
      clearTicker(root);
    });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) {
        startTicker(root);
      }
    });

    startTicker(root);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ingredient-spotlight]').forEach(function (el) {
      if (el.getAttribute('data-ingredient-spotlight-initialized') === 'true') return;
      el.setAttribute('data-ingredient-spotlight-initialized', 'true');
      init(el);
    });
  }

  document.addEventListener('visibilitychange', function () {
    pausedByVisibility = document.visibilityState === 'hidden';
    document.querySelectorAll('[data-ingredient-spotlight]').forEach(function (root) {
      clearTicker(root);
      if (!pausedByVisibility) startTicker(root);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && typeof event.target.querySelectorAll === 'function') {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || typeof event.target.querySelectorAll !== 'function') return;
    event.target.querySelectorAll('[data-ingredient-spotlight]').forEach(function (root) {
      clearTicker(root);
      root.removeAttribute('data-ingredient-spotlight-initialized');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
